import { render, staticRenderFns } from "./createVehicle.vue?vue&type=template&id=81ac8fd2&"
import script from "./createVehicle.vue?vue&type=script&lang=js&"
export * from "./createVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports